export default __webpack_public_path__ + "static/cookie-a291fe63fab52cb020f338c07a077d11.svg";